import { DEFAULT_LIMIT, DEFAULT_SKIP, LIMIT } from 'Src/consts/table';
import { Count } from 'Src/models/count';
import { SchoolHouse } from 'Src/models/house';
import { superAdminGet, superAdminPost } from './api';

export interface SuperAdminHouseCreateData {
  name: string;
  description?: string;
  pic?: string;
  colors?: string[];
}

export interface SuperAdminHousesFilter {
  limit?: number;
  skip?: number;
  order?: string;
  where?: any;
}

const DEFAULT_FILTER: SuperAdminHousesFilter = {
  limit: LIMIT,
  skip: DEFAULT_SKIP,
  order: 'name ASC'
};

function buildFilter(filter: SuperAdminHousesFilter = DEFAULT_FILTER): SuperAdminHousesFilter {
  return {
    where: filter.where || {},
    skip: typeof filter.skip === 'number' ? filter.skip : DEFAULT_FILTER.skip,
    limit: typeof filter.limit === 'number' ? filter.limit : DEFAULT_FILTER.limit,
    order: filter.order || DEFAULT_FILTER.order
  };
}

export function getSuperAdminSchoolHouses(
  schoolId: string,
  filter: SuperAdminHousesFilter = DEFAULT_FILTER
): Promise<SchoolHouse[]> {
  return superAdminGet<SchoolHouse[]>(`/schools/${schoolId}/houses`, {
    params: {
      filter: buildFilter(filter)
    }
  });
}

export function getAllSuperAdminSchoolHouses(schoolId: string, where?: any): Promise<SchoolHouse[]> {
  return superAdminGet<SchoolHouse[]>(`/schools/${schoolId}/houses`, {
    params: {
      filter: {
        where: where || {},
        skip: DEFAULT_SKIP,
        limit: DEFAULT_LIMIT,
        order: DEFAULT_FILTER.order
      }
    }
  });
}

export function getSuperAdminSchoolHousesCount(schoolId: string, where?: any): Promise<Count> {
  const config =
    typeof where !== 'undefined'
      ? {
          params: {
            filter: {
              where
            }
          }
        }
      : {};

  return superAdminGet<Count>(`/schools/${schoolId}/houses/count`, config);
}

export function getSuperAdminSchoolHouse(schoolId: string, houseId: string): Promise<SchoolHouse> {
  return superAdminGet<SchoolHouse>(`/schools/${schoolId}/houses/${houseId}`);
}

export function createSuperAdminSchoolHouse(
  schoolId: string,
  data: SuperAdminHouseCreateData
): Promise<SchoolHouse> {
  return superAdminPost<SchoolHouse>(`/schools/${schoolId}/houses`, data);
}
